import { type ReactNode } from 'react';

export function getByPlaceholderText(
  isActive: boolean,
  label?: ReactNode | null,
  placeholder?: string
) {
  if (placeholder === undefined) {
    return;
  }
  if (label && !isActive) {
    return;
  }
  return placeholder;
}
